import Empresas from "../../empresas.json";

const extras = [
  {
    id: 1,
    ga: {
      id: "UA-16235416-4",
    },
    imgs: {
      logo: require("../images/clic/logo.png"),
      logo_impressao: require("../images/clic/logo-impressao.png"),
      logo_login: require("../images/clic/logo-login.png"),
      logo_assessor_virtual: require("../images/clic/avatar-vr.svg"),
      favicon: require("../images/clic/logo-login.png"),
    },
    assessor_virtual: {
      logo: require("../images/clic/avatar-vr.svg"),
      whatsapp: "+55 (51) 3037-9336",
      email: "assessorvirtual@vilarica.com.br",
    },
    hotjar: `
        (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:3855898,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');  
        `,
  },
  {
    id: 2,
    ga: {
      id: "G-RG2W38JDWK",
    },
    imgs: {
      logo: require("../images/easy/logo.png"),
      logo_impressao: require("../images/easy/logo-impressao.png"),
      logo_login: require("../images/easy/logo-sao-luiz.png"),
      favicon: require("../images/easy/logo-login.png"),
    },
  },
  {
    id: 3,
    ga: {
      id: null,
    },
    imgs: {
      logo: require("../images/easy-money/logo.png"),
      logo_impressao: require("../images/easy-money/logo-impressao.png"),
      logo_login: require("../images/easy-money/logo-login.png"),
      favicon: require("../images/easy-money/favicon.ico"),
    },
  },
];

export const empresas = Empresas.map(empresa => {
  let regex = new RegExp(empresa.regex);
  let active = regex.test(location.href) || window.empresa == empresa.title;
  return { ...empresa, ...extras.find(e => e.id == empresa.id), active };
});



export const empresa = empresas.find(({ active }) => active || process.env.NODE_ENV === 'development');


document.title = empresa.pageTitle;
const $icon = document.head.querySelector("[rel~=icon]");
if ($icon) {
  document.head.querySelector("[rel~=icon]").href = empresa.imgs.favicon;
}



export default {
  empresas,
  empresa,
};
